import { css } from "@/utils/css";
import { __ } from "@wordpress/i18n";
import { v4 as uuid } from "uuid";

type Props = {
    label?: string;
    help?: string;
    value?: string;
    onChange?: (value: string) => void;
    placeholder?: string;
    className?: string;
};

export function TextInput({ label, help, value, onChange, placeholder, className }: Props) {
    const id = uuid();

    return (
        <label htmlFor={id} className={css(className || "")}>
            <span className={css("form-label")}>{label}</span>
            <input
                id={id}
                type="text"
                className={css("form-input")}
                value={value}
                onChange={(e) => onChange?.(e.target.value)}
                placeholder={placeholder || __("Type here...", "antimanual")}
            />
            {help && <p className={css("form-help")}>{help}</p>}
        </label>
    );
}
